import React, {ReactElement, ReactNode, useEffect} from "react";
import "./FlintLoadingWrapper.scss"

export default function FlintLoadingWrapper(props: flintLoadingWrapperProps) {
    const loadingPanelMarkup = (
        <div className="k-loading-mask custom-loader">
            <span className="k-loading-text">... loading ...</span>
            {props.showMessage ? <span className="loading-message">
                {props.showMessage}
                {props.showPercent ? <div className="loading-percentage">{props.showPercent}%</div> : null}
            </span> 
                : <>{props.showPercent ? <span className="loading-message">
                    <div className="loading-percentage">{props.showPercent}%</div></span> : null}</>
            }
            <div className="k-loading-image"/>
            <div className="k-loading-color"/>
        </div>
    );
    const loadingWrapperClassName = props.loadingWrapperClassName ? `loading-wrapper ${props.loadingWrapperClassName}` : "loading-wrapper";
    return (
        <div className={loadingWrapperClassName}>
            {props.children}
            {props.showLoading && loadingPanelMarkup}
        </div>
    )
}

export interface flintLoadingWrapperProps {
    showLoading: boolean;
    showMessage?:string;
    showPercent?:number; // INTEGER
    children: ReactNode;
    loadingWrapperClassName?: string;
}